import React from 'react';
import { useLocalization } from 'Hooks';
import useSessionTimeout from 'Hooks/useSessionTimeout';
import { DialogWithActions } from 'Components/DialogWithActions';

const SessionTimeoutDialog: React.FC = () => {
  const { isWarningOpen, secondsLeft, extendSession, performLogout } = useSessionTimeout();
  const localization = useLocalization();

  const title =
    localization?.web_session_timeout_title ?? 'Oturumunuz sona ermek üzere';
  const baseText =
    localization?.web_session_timeout_desc ??
    'Hareketsizliğinizden dolayı oturumunuz {{seconds}} saniye içinde sonlanacak. Devam etmek istiyor musunuz?';
  const text = baseText.replace('{{seconds}}', String(secondsLeft));

  return (
    <>
      {/* Ekran okuyucu için canlı duyuru */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0,0,0,0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {isWarningOpen
          ? `Oturumunuz ${secondsLeft} saniye içinde sonlanacak. Devam etmek için butona basın.`
          : ''}
      </div>

      <DialogWithActions
        disableClickOutside
        title={title}
        text={text}
        primaryButton={{
          label: localization?.web_session_timeout_extend ?? 'Devam Et',
          handleClick: extendSession,
        }}
        secondaryButton={{
          label: localization?.web_session_timeout_logout ?? 'Çıkış Yap',
          handleClick: performLogout,
          type: 'outlined',
        }}
        hide={extendSession}
        open={isWarningOpen}
      />
    </>
  );
};

export default SessionTimeoutDialog;